export enum DutyStatus {
  Scheduled = 'scheduled',
  InProgress = 'inProgress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}
